import axiosInstance from "../../../axios";

// getting list of organization members
export const getOrganizationMembers = async () => {
  const {
    data: {organizationMembers},
  } = await axiosInstance.get("organization/members");
  return organizationMembers;
};

export const getCountries = async (language) => {
  const {data} = await axiosInstance.get("references/countries");
  return data?.map((country) => ({
    label: country[`name_${language}`] ?? country.name,
    value: country.id,
  }));
};
